import type { INetworkStatusRepository } from '@/domain/repositories/INetworkStatusRepository';
import { createNetworkStatus } from '@/domain/entities/NetworkStatus';
import type { NetworkStatus } from '@/domain/entities/NetworkStatus';

/**
 * Implementação que usa a Navigator API do browser para observar
 * o status de rede. Registra listeners nos eventos "online" e "offline"
 * do window para notificar subscribers em tempo real.
 */
export class BrowserNetworkStatusRepository implements INetworkStatusRepository {
  getCurrent(): NetworkStatus {
    return createNetworkStatus(navigator.onLine);
  }

  subscribe(listener: (status: NetworkStatus) => void): () => void {
    const handleOnline = (): void => listener(createNetworkStatus(true));
    const handleOffline = (): void => listener(createNetworkStatus(false));

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }
}
